function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:none}.cls-3{stroke-width:3px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rechteck_370",
  fill: "none",
  d: "M0 0H28V28H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1030",
  transform: "translate(-316 -740)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_47",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "cls-2",
  transform: "translate(317.5 743)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_48",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "cls-2",
  transform: "translate(317.5 761)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_49",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "cls-2",
  transform: "translate(317.5 752)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Linie_24",
  d: "M0 0L18 0",
  className: "cls-3",
  transform: "translate(324.5 745.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Linie_25",
  d: "M0 0L18 0",
  className: "cls-3",
  transform: "translate(324.5 754.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Linie_26",
  d: "M0 0L18 0",
  className: "cls-3",
  transform: "translate(324.5 763.5)"
}));

function SvgMenuMehr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu_mehr",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMehr);
export default __webpack_public_path__ + "static/media/menu_mehr.ecf1c308.svg";
export { ForwardRef as ReactComponent };